export default __webpack_public_path__ + "static/media/announcement-highlight-details-outer.eabceea5.svg";